export default __webpack_public_path__ + "static/media/eye-icon.e62dfb93.svg";